module.exports = __webpack_public_path__ + "img/5.ff09416e.jpg";